import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Chat, fetchChats } from '../../utils/axios/api';
import { initAuth, login, logout, resetAuth } from './auth-slice';

interface ChatsState {
  items: Chat[];
}

const initialState: ChatsState = {
  items: [],
};

export const refreshChats = createAsyncThunk('chats/refresh', fetchChats);

const chatsSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetAuth, () => initialState)
      .addCase(logout.fulfilled, () => initialState)
      .addCase(initAuth.rejected, () => initialState)
      .addCase(initAuth.fulfilled, (state, action) => {
        state.items = action.payload.chats;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.items = action.payload.chats;
      })
      .addCase(refreshChats.fulfilled, (state, action) => {
        state.items = action.payload;
      });
  },
});

export default chatsSlice.reducer;
